<template>
  <el-breadcrumb
class="app-breadcrumb"
separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
v-for="(item, index) in levelList"
:key="item.path">
        <span
          v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
          class="no-redirect"
          >{{ item.meta.title }}</span
        >
        <a
v-else
@click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      const matched = []
      if (this.$route.meta.parent) {
        const routeProps = this.$router.resolve({
          name: this.$route.meta.parent,
        });
        matched.push(routeProps.route)
      }
      matched.push(this.$route);
      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return (
        name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase()
      );
    },
    handleLink(item) {
      const { redirect, name } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
  },
};
</script>

<style lang="scss">
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 18px;
  padding: 12px 24px;
  font-weight: 500 !important;
  margin-bottom: -8px;
  background-color: #ffffff;
  width: 100%;
  .no-redirect {
    color: #4f4f4f;
    cursor: text;
  }
  .el-breadcrumb__item {
    text-transform: uppercase;
    .el-breadcrumb__inner {
      font-weight: 600 !important;
      line-height: 1.5;
      display: inline-block;
      span {
        display: inline-block;
      }
    }
  }
}
</style>
